import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
  })
  export class FileUploadComponent {
    afuConfig: any;
    router: any;
  constructor(router: Router){
    this.router = router;
    this.afuConfig = {
      uploadAPI: {
        url:"https://slack.com/api/files.upload"
      },
      // replaceTexts: {
      //   selectFileBtn: 'Select Files',
      //   resetBtn: 'Reset',
      //   uploadBtn: 'Upload',
      //   dragNDropBox: 'Drag N Drop',
      //   attachPinBtn: 'Attach Files...',
      //   afterUploadMsg_success: 'Successfully Uploaded !',
      //   afterUploadMsg_error: 'Upload Failed !',
      //   sizeLimit: 'Size Limit'
      // },
      theme: "default"
    };
  }

  OnBackClick($event: any) {
    this.router.navigateByUrl('/');
  }

  onClick($event: any){
    this.router.navigateByUrl('/east-coast-2');
  }

  onClick1($event: any){
    this.router.navigateByUrl('/thankyou');
  }
}
